import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkReferralLink } from "./helpers/helpers";
import * as paths from "./constants/paths";

const PrivateRoute = () => {
  const referralLink = localStorage.getItem("ref");
  const compaign_name = localStorage.getItem("compaign_name");
  const authToken = useSelector((state) => state.fetchSignin.authToken);
  let location = useLocation();

    const isAlreadyInBasePath = window.location.pathname.includes(`${paths.SITE_BASE_URL}`);

const targetPath = checkReferralLink(referralLink)
  ? `${isAlreadyInBasePath ? '' : `/${paths.SITE_BASE_URL}`}/signin?ref=${referralLink}&compaign_name=${compaign_name}`
  : `${isAlreadyInBasePath ? '' : `/${paths.SITE_BASE_URL}`}/signin`;

  return authToken ? (
    <Outlet />
  ) : (
  

<Navigate
  to={targetPath}
  replace
  state={{ from: location }}
/>

  );
};

export default PrivateRoute;
